import SimpleFeedbackOverlay from '../modules/simple-feedback-overlay/src/simple-feedback-overlay';

export default SimpleFeedbackOverlay;



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/ref/simple-feedback-overlay.js